import React from "react";
import { rmEmail, rmNumber } from "../../utils/helper";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./index.scss";
import { AvatarIcon, EmailIcon, PhoneIcon, PorfileIcon } from "../../assets/images/svg/svg";

const RMCard = ({ isFresh: propIsFresh, isRenewal: propIsRenewal }) => {
  const customerData = useSelector((state) => state.common?.customerData);
  const detailsData = useSelector(
    (state) => state.orders?.selectedOrder?.detailsData,
  );
  const location = useLocation();

  const isRenewal =
    propIsRenewal ??
    (propIsFresh !== undefined ? !propIsFresh : undefined) ??
    (location?.pathname?.toLowerCase()?.includes("renewal") ||
      detailsData?.order_type === "RENEWAL");

  const isFresh = !isRenewal;

  const rmName = customerData?.rm_name;
  const rmPhone =
    isFresh && customerData?.rm_mobile ? customerData.rm_mobile : rmNumber;
  const email =
    isFresh && customerData?.rm_email ? customerData.rm_email : rmEmail;

  return (
    <div className="rm-container">
      {email || rmPhone || rmName ? (
        <>
          <div className="side-card-title">Relationship Manager</div>
          {rmName && (
            <div className="side-card-value">
              <span className="icon-wrapper">
                <PorfileIcon />
              </span>
              {rmName}
            </div>
          )}
          <div className="side-card-value">
            <span className="icon-wrapper">
              <EmailIcon />
            </span>
            {email}
          </div>
          <div className="side-card-value">
            <span className="icon-wrapper">
              <PhoneIcon />
            </span>
            {rmPhone}
          </div>
        </>
      ) : (
        <div className="no-rm-assign">
          <span className="avatar-img">
            <AvatarIcon />
          </span>
          <div className="title">No Manager Assigned</div>
          <div className="subtitle">
            We’ll soon assign you a relationship manager
          </div>
        </div>
      )}
    </div>
  );
};

export default RMCard;
